import { getUuid } from 'src/utils/url';

/**
 * Locate the group and print for the scanned piece in a single pass.
 *
 * @param {object} params
 * @param {string|null} params.scannedPieceUuid - UUID from the URL `?scannedPiece=` param.
 * @param {object} params.piecesByPrintUri - Pieces keyed by their print URI.
 * @param {Array<{prints: Array<{uri: string}>}>} params.printGroups - Computed print groups.
 * @returns {{ groupIndex: number|null, matchedPrint: object|null }}
 */
export function findScannedPieceInfo({ scannedPieceUuid, piecesByPrintUri, printGroups }) {
  if (!scannedPieceUuid || !piecesByPrintUri || !Object.keys(piecesByPrintUri).length) {
    return { groupIndex: null, matchedPrint: null };
  }
  const matchingPrintUri = Object.keys(piecesByPrintUri).find((printUri) => {
    const piece = piecesByPrintUri[printUri];
    return piece && getUuid(piece.uri) === scannedPieceUuid;
  });
  if (!matchingPrintUri) return { groupIndex: null, matchedPrint: null };
  const groupIndex = printGroups.findIndex((g) => g.prints.some((p) => p.uri === matchingPrintUri));
  if (groupIndex === -1) return { groupIndex: null, matchedPrint: null };
  const matchedPrint = printGroups[groupIndex].prints.find((p) => p.uri === matchingPrintUri) || null;
  return { groupIndex, matchedPrint };
}
